<template>
    <div id="id-div-footer" class="div-footer" ref="refFooterDiv"
         :style="{position: position, bottom:bottom, width:width}">
        <!--        <p class="p-footer" :style="{marginLeft:footerLeft+'px'}">-->
        <!--            <a href="http://www.hdmooc.com/pages/about.html" style="margin-left: 0;">关于我们</a> | <a href="">联系我们</a>-->
        <!--            | <a href="http://www.hdmooc.com/helper/index.html">帮助中心</a> | <a-->
        <!--            href="http://www.hdmooc.com/pages/teacher.html">老师招募</a> | <a-->
        <!--            href="http://www.hdmooc.com/pages/user.html">服务协议</a>-->
        <!--        </p>-->
        <!--        <p class="p-footer" :style="{marginLeft:footerLeft+'px'}">-->
        <!--            <span ref="hdMsg">-->
        <!--                恒点信息(hdvrar.com)旗下实用技能学习平台。与顶级机构、院校和优秀讲师合作，为您提供海量优质课程，以及创新的在线学习体验，帮助您获得全新的个人发展和能力提升。</span>-->
        <!--        </p>-->
        <p class="p-footer" style="text-align: center;">
            <span ref="rootLeft">&copy; 2016-{{ endYear }} 南京恒点信息技术有限公司 版权所有 <a
                href="苏ICP备16057523号-2" style="margin-left: 3em;">苏ICP备16057523号-2</a></span>
            <!--            <span :style="{marginLeft: rootMarginLeft+'px'}" ref="rootRight">电话：<a-->
            <!--                href="tel:025-83222270">025-83222270</a> 移动APP: <a href="" class="appLink">-->
            <!--                    <i class="iconfont icon-apple"></i> <span>iPhone</span>-->
            <!--                </a><a href="" class="appLink"><i class="iconfont icon-android"></i> <span>android</span></a></span>-->
        </p>
    </div>
</template>

<script>
export default {
    name: 'FooterLogined',
    created () {
        this.endYear = this.getCurrentYear()
    },
    updated () {
    },
    activated () {
        console.log('######', window.location.href)
    },
    mounted () {
        let that = this
        this.$nextTick(function () {
            // let width = this.$refs.hdMsg.offsetWidth
            // that.footerLeft = (document.body.offsetWidth - width) / 2
            // that.rootMarginLeft = width - this.$refs.rootLeft.offsetWidth - this.$refs.rootRight
            //     .offsetWidth - 10
            that.setFooter()
            window.addEventListener('setItemEvent', (e) => {
                if (e.key === 'WindowsOnResize') {
                    //刷新页面
                    that.setFooter()
                }
            })
        })
    },
    data: function () {
        return {
            endYear: 2019,
            footerLeft: 0,
            position: 'static',
            bottom: 0,
            width: 'auto',
            rootMarginLeft: 0
        }
    },
    methods: {
        setFooter () {
            //如果判断footer放位置
            if (document.body.offsetHeight < window.innerHeight) {
                //绝对定位
                this.position = 'absolute'
                this.width = '100%'
                this.bottom = 0
            } else {
                this.position = 'static'
                this.width = 'auto'
                this.bottom = 0
            }
        }
    }
}
</script>

<style scoped="scoped">
.div-footer {
    position: absolute;
    bottom: 0;
    background-color: #EEEEEE;
    width: 100%;
    padding: 10px 0;
    font-size: 16px;
}

.p-footer {
    color: #666666;
    margin: 0;
    padding: 0;
    line-height: 40px;
}

a {
    color: #666666;
    text-decoration: none;
    margin-left: 0.5em;
    margin-right: 0.5em;
}

a:hover {
    color: #00a4e0;
}

a img {
    height: 25px;
    position: relative;
    top: 8px;
}

.appLink {
    background-color: #1b1a1f;
    padding: 3px 8px 3px 5px;
    border-radius: 5px;
}

.appLink span {
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/public/FooterLogined.vue